import React from 'react';
import styled from 'styled-components';
import TooltipMui, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const BaseTooltip = styled(({ className, ...props }: TooltipProps) => (
  <TooltipMui {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

// Stable reference — inline PopperProps triggers Popper reposition → setState → re-render loops.
const tooltipPopperProps: TooltipProps['PopperProps'] = { style: { marginBottom: -12 } };

const Tooltip = ({ children, html, placement = 'bottom', arrow = false }: any) => {
  return (
    <BaseTooltip PopperProps={tooltipPopperProps} placement={placement} arrow={arrow} title={html}>
      {children}
    </BaseTooltip>
  );
};

export default Tooltip;
